import { useRef } from 'react';
import DatePicker from '@/components/DatePicker';
import { parseLocalDate, formatDateForApi } from '../utils';

const DateCell = ({ row, column, value, onChange, portalContainer }) => {
  const cellRef = useRef(null);
  const datePickerRef = useRef(null);
  const isEditable = column.editable !== false;
  const initialValue = parseLocalDate(value);

  const handleDateChange = (dates) => {
    if (!onChange || !isEditable) {
      return;
    }

    if (!dates || dates.length === 0) {
      onChange(null, { row, column });
      return;
    }

    const selectedDate = Array.isArray(dates) ? dates[0] : dates;

    if (!selectedDate) {
      return;
    }

    const formatted = formatDateForApi(selectedDate);

    onChange(formatted, { row, column });
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const trigger = cellRef.current?.querySelector('[role="button"]') || cellRef.current?.querySelector('button') || datePickerRef.current;

      if (trigger) {
        trigger.click();
      }
    }
  };

  return (
    <div className={`comp-grid-table-cell date-cell ${isEditable ? 'editable' : 'read-only'} ${column.cellClassName || ''}`} ref={cellRef} tabIndex={isEditable ? 0 : -1} onClick={(e) => e.stopPropagation()} onKeyDown={handleKeyDown}>
      <div ref={datePickerRef}>
        <DatePicker mode="single" showActions={false} showIcon={true} onChange={handleDateChange} initialValue={initialValue} size="sm" container={portalContainer} emptyDateLabel={column.emptyDateLabel || 'No date'} />
      </div>
    </div>
  );
};

export default DateCell;
